export const requestTypeLists = [
  "concept",
  "submitted",
  "refused",
  "cancelled",
  "deliver",
  "taken_from_storage",
  "checked_for_delivery",
  "loaded_for_delivery",
  "delivered",
  "pickup",
  "loaded_for_storage",
  "checked_for_storage",
  "in_storage",
];
